import React, { Component } from 'react';
import Navbar from '../Navbar'
import { Input, Collapse, Alert, Row, Col, Card, Button, CardHeader, CardBody, Badge, Spinner, InputGroup, InputGroupAddon, InputGroupText, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Select from 'react-select';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import paginationFactory from 'react-bootstrap-table2-paginator';

const { proxy } = require('../../ip_api.config')

let columns = [
	{
		dataField: 'rowNo',
		text: 'No',
		headerStyle: (colum, colIndex) => {
			return { width: '10%', textAlign: 'center' };
		},
		style: { textAlign: 'center' }
	},
	{
		dataField: 'iBrand2',
		text: 'IBrand 2',
		headerStyle: (colum, colIndex) => {
			return { width: '15%', textAlign: 'center' };
		},
		style: { textAlign: 'center' }
	},
	{
		dataField: 'modelDesc',
		text: 'Model',
		headerStyle: (colum, colIndex) => {
			return { width: '40%', textAlign: 'center' };
		},
	},
	{
		dataField: 'sizeDesc',
		text: 'Size',
		headerStyle: (colum, colIndex) => {
			return { width: '15%', textAlign: 'center' };
		},
		style: { textAlign: 'center' }
	},
	{
		dataField: 'rangePrice',
		text: 'Range Price',
		headerStyle: (colum, colIndex) => {
			return { width: '18%', textAlign: 'center' };
		},
		style: { textAlign: 'center' }
	},
	{
		dataField: 'remark',
		text: 'Remark',
		headerStyle: (colum, colIndex) => {
			return { width: '15%', textAlign: 'center' };
		}
	},
	{
		dataField: 'action',
		text: '',
		headerStyle: (colum, colIndex) => {
			return { width: '20%', textAlign: 'center' };
		},
		style: { textAlign: 'center' }

	},
];

class Film_DisplaySameModel extends Component {

	constructor(props) {
		super(props)
		this.state = {
			filesDisplay: [],
			filterList: [
				{
					displayName: 'IBrand 2',
					name: 'iBrand2',
					value: '',
					inputType: 'option',
					option: [],
				},
				{
					displayName: 'Model',
					name: 'modelDesc',
					value: '',
					inputType: 'textarea',
					option: [],
				},
				{
					displayName: 'Size',
					name: 'sizeDesc',
					value: '',
					inputType: 'text',
					option: [],
				},
				{
					displayName: 'Range Price',
					name: 'rangePrice',
					value: '',
					inputType: 'text',
					option: [],
				},
				{
					displayName: 'Remark',
					name: 'remark',
					value: '',
					inputType: 'text',
					option: [],
				},
			],
			productData: [],
			uploadContent: [],
			deleteList: [],
			customAlert: {
				open: false,
				messages: '',
				status: ''
			},
			openModal: -1,
			productById: [],
			sameModelId: '',
			type: '',
		}
	}

	componentDidMount() {
		this.get_Ibrand2Filter()
		this.getColumn()
		// this.get_dataSameModel()
		// this.get_uploadContentFilter({ userId: localStorage.getItem("ID_User") })
		this.isMobile()
	}

	isMobile = () => {
		if (navigator.userAgent.match(/(iPad|Android)/i) && (window.innerWidth > 800)) {
			console.log('noooooooooo mobile')
			// return false;
		} else {
			if (navigator.userAgent.match(/(Mobile|Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone)/i)) {
				console.log('yes mobile')
			} else {
				console.log('noooooooooo mobile')
			}

			// return (navigator.userAgent.match(/(Mobile|Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone)/i)) ? true : false;
		}
	}

	getColumn = () => {
		let departmentRole = localStorage.getItem("DepartmentNo");
		if (departmentRole != 'D11') {
			columns.map((val, i) => {
				if (val.dataField === 'action') {
					columns.splice(i, 1)
				}
			})
		}
	}

	get_Ibrand2Filter = (selected) => {
		let url = proxy.server + '/flim/getIbrand2Filter'
		fetch(url, {
			method: "POST",
			headers: {
				// Accept: "application/json",
				"Content-Type": "application/json;charset=utf-8"
			},
			body: JSON.stringify({ id: "GET_ALL" })
		})
			.then(response => response.json())
			.then((responseJson) => {
				console.log("responseJson [get_productNameFilter]", responseJson)
				let filterList = this.state.filterList
				let arr = []

				switch (responseJson.status) {
					case 200:
						arr.push({ value: '', label: '----------ทั้งหมด---------' })
						responseJson.result.map(function (val, i) {
							arr.push({ value: val.iBrand2Id, label: val.iBrand2Name })
						})
						filterList[0].option = arr;
						this.setState({ filterList: filterList })
						break;
					default:
						filterList[0].option = arr;
						this.setState({ filterList: filterList })
				}
			})
	}


	get_uploadContentFilter = (data) => {
		let url = proxy.server + '/flim/getUploadByGroup'
		fetch(url, {
			method: "POST",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json;charset=utf-8"
			},
			body: JSON.stringify(data)
		})
			.then(response => response.json())
			.then((responseJson) => {
				console.log("responseJson [get_uploadByGroup]", responseJson)
				let arr = []
				let filterList = this.state.filterList
				switch (responseJson.status) {
					case 200:
						responseJson.result.map(function (val, i) {
							arr.push({ value: val.typeNo, label: val.label })
						})

						filterList[7].option = arr;
						this.setState({ filterList: filterList })

						break;
					default:
						filterList[7].option = [];
						this.setState({ filterList: filterList })
				}
			})
	}

	get_uploadByGroup = (data, whereGroup) => {
		let url = proxy.server + '/flim/getUploadByGroup'
		fetch(url, {
			method: "POST",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json;charset=utf-8"
			},
			body: JSON.stringify(data)
		})
			.then(response => response.json())
			.then((responseJson) => {
				console.log("responseJson [get_uploadByGroup]", responseJson)
				switch (responseJson.status) {
					case 200:
						let files = {};
						let collapseUploadList = [];
						responseJson.result.forEach(item => {
							collapseUploadList.push(false)
							files[`${item.fieldName}`] = (item.inputType === 'textarea') ? "" : [];
							item.dataCount = 0;
						});

						this.setState({ uploadContent: responseJson.result, files: files, collapseUploadList: collapseUploadList })

						this.get_dataUploadedByOption(whereGroup)
						break;
					default: this.setState({ uploadContent: [] })
				}
			})
	}

	get_dataSameModel = (data) => {
		let url = proxy.server + '/flim/getDataSameModel'
		fetch(url, {
			method: "POST",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json;charset=utf-8"
			},
			body: JSON.stringify(data)
		})
			.then(response => response.json())
			.then((responseJson) => {
				console.log("responseJson [get_uploadByGroup]", responseJson)
				switch (responseJson.status) {
					case 200:
						let res = responseJson.result;
						for (let key in res) {
							res[key].rowNo = parseInt(key) + 1;
							res[key].action = (
								<React.Fragment>
									<Button onClick={() => this.handleEdit(res[key].sameModelId)} color="warning"><i class="fa fa-pencil" aria-hidden="true"></i> Edit</Button> &nbsp;
								</React.Fragment>
							)

						}
						this.setState({ productData: responseJson.result })
						break;
					default: this.setState({ productData: [] })
				}
			})
	}

	get_dataUploadedByOption = (whereGroup) => {
		let url = proxy.server + '/flim/getDataUploadedByOption'
		fetch(url, {
			method: "POST",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json;charset=utf-8"
			},
			body: JSON.stringify(whereGroup)
		})
			.then(response => response.json())
			.then((responseJson) => {
				console.log("responseJson [get_dataUploadedByItem]", responseJson)
				switch (responseJson.status) {
					case 200:
						const { files } = this.state;
						let filesCopy = files;
						responseJson.result.forEach(item => {
							for (let key in filesCopy) {
								if (key === item.fieldName) {
									switch (item.inputType) {
										case 'file':
											item.fileName = item.value.substring((item.value.lastIndexOf('/') + 1));
											filesCopy[`${item.fieldName}`].push(item)
											break;
										case 'textarea':
											filesCopy[`${item.fieldName}`] = item.value
											break;
										case 'text':
											filesCopy[`${item.fieldName}`].push({ value: item.value, remark: item.remark })
											break;
									}
								}
							}
							let uploadContent = this.state.uploadContent.slice();
							for (let i = 0; i < uploadContent.length; i++) {

								if (item.typeNo === uploadContent[i].typeNo) {
									uploadContent[i].dataCount++;
								}
							}
						});
						this.setState({ files: filesCopy })

						break;
					default:
				}
			})
	}

	renderType = (type, name) => {
		switch (type) {
			case 'textarea':
				return (
					this.state.files[name] ?
						<Input type="textarea" value={this.state.files[name]} disabled />
						: ''
				)
			case 'text':
				return (
					this.state.files[name].length > 0 &&
					this.state.files[name].map((val, i) => {
						return (
							<div style={{ display: 'flex', marginBottom: '10px' }}>
								<div className="col-md-6 col-sm-4" id="inputRow" style={{ padding: '0' }}>
									<InputGroup>
										<InputGroupAddon addonType="prepend">
											<InputGroupText>Link</InputGroupText>
										</InputGroupAddon>
										<Input type="text" value={val.value} disabled />
									</InputGroup>
								</div> &nbsp;
								<div className="col-md-6 col-sm-4" id="inputRow" style={{ padding: '0' }}>
									<InputGroup>
										<InputGroupAddon addonType="prepend">
											<InputGroupText>หมายเหตุ</InputGroupText>
										</InputGroupAddon>
										<Input type="text" name={name} value={val.remark} disabled />
									</InputGroup>
								</div>
							</div>
						)
					})
				)
			case 'file':
				return (
					<React.Fragment>
						{
							this.state.files[name] && this.state.files[name].map((val, i) => {
								return (
									<div style={{ display: 'flex', margin: '5px' }} key={i}>
										<div style={{ flex: '1' }}>
											{
												val.typeName && val.typeName === 'IMAGE' ?
													<div style={{ display: 'flex', alignItems: 'center' }}>
														<img src={`${proxy.server}/${val.value}`} onClick={() => this.handleDisplayImg(`${proxy.server}/${val.value}`)} style={{ maxHeight: '70px', maxWidth: '70px', width: '70px', height: '70px', objectFit: 'cover', cursor: 'pointer' }} />
														<span style={{ marginLeft: '5px' }}>{val.fileName}</span>
													</div>
													: val.typeName === 'FILE' &&
													<div style={{ display: 'flex', alignItems: 'center' }}>
														<div style={{ flex: '1' }}>
															<span>{val.fileName}</span>
														</div>
														<a href={`${proxy.server}/${val.value}`}>
															<Button color="info" >Download File</Button>
														</a>
													</div>
											}
										</div>
									</div>
								)
							})
						}
					</React.Fragment>
				)
		}
	}

	collapseUploadList = (index) => {
		let collapseUploadList = this.state.collapseUploadList;
		collapseUploadList[index] = !collapseUploadList[index];
		this.setState({ collapseUploadList: collapseUploadList })
	}

	handleChangeFilter = (value, fieldName) => {

		console.log('object', value)

		let filterList = this.state.filterList.slice()

		filterList.map((val, i) => {
			if (val.name === fieldName) {
				if (value === null) {
					// for uploadContent filter
					value = []
				}
				val.value = value
			}
		})
		this.setState({ filterList: filterList })
	}

	handleSearchSubmit = () => {
		this.setState({ itemId: this.state.filterList })
		let whereGroup = {}
		this.state.filterList.map((val, i) => {
			whereGroup[`${val.name}`] = val.value;
		})

		console.log('object uploadContentList [handleSearchSubmit]', whereGroup)

		this.get_dataSameModel(whereGroup)
		// this.get_uploadByGroup({ userId: localStorage.getItem("ID_User"), }, whereGroup)

	}

	handleDisplayImg = (src) => {
		let modal = document.getElementById("showImg");
		let modalImg = document.getElementById("imgContent");
		modal.style.display = "block";
		modalImg.src = src;
	}

	handleCloseDisplayImg = () => {
		let modal = document.getElementById("showImg");
		modal.style.display = "none";
	}

	handleEdit = (data) => {
		console.log('object data data', data)

		if (data !== -1) {
			this.setState({
				openModal: data,
			});

			let productById = this.state.productData.filter((val, i) => {
				return val.sameModelId === data
			})

			console.log('object productById', productById)

			this.setState({ productById: productById, sameModelId: data, type: 'edit' })
		} else {
			this.setState({
				openModal: 0,
				sameModelId: -1,
				productById: [],
				type: 'add'
			});
		}

	}

	closeModalEdit = () => {
		this.setState({
			openModal: -1,
			activeIdModal: -1,
			sameModelId: '',
			productById: [],
		});
	}

	setCustomAlert = (messages, status) => {
		this.setState({ customAlert: { open: true, messages: messages, status: status } })

		if (status !== 'processing') {
			let load
			window.clearTimeout(load);
			load = window.setTimeout(() => {
				this.setState({ customAlert: { open: false, messages: '', status: '' } })
			}, 2000)
		}
	}

	render() {
		const { filterList, productData } = this.state;
		let departmentRole = localStorage.getItem("DepartmentNo");

		return (
			<React.Fragment>
				<Navbar nav={'Flim'} menu={'Flim_ManageProductImage'} />
				<div style={{ padding: '10px' }}>
					<Card style={{ margin: '10px' }}>
						<CardHeader><i class="fa fa-info-circle fa-lg" aria-hidden="true"></i> ข้อมูลสินค้า</CardHeader>
						<CardBody>
							<div style={{ padding: '10px' }}>
								<Row>
									{
										filterList.map((val, i) => {
											return (
												<Col xs="12" sm="12" md="6" style={{ padding: '5px' }} >
													<Row>
														<Col xs="12" sm="4" md="3">{val.displayName}:</Col>
														{
															val.inputType === 'option' ?
																<Col xs="12" sm="8" md="9">
																	<Select
																		defaultValue={val.value}
																		value={val.option.filter(option => option.value === val.value)}
																		onChange={(e) => this.handleChangeFilter(e.value, val.name)}
																		options={val.option}
																		placeholder={'ค้นหา ' + val.displayName}
																	/>
																</Col>
																: val.inputType === 'multiOption' ?
																	<Col xs="12" sm="8" md="9">
																		<Select
																			defaultValue={val.value}
																			isMulti
																			options={val.option}
																			withAll={true}
																			closeMenuOnSelect={false}
																			onChange={(e) => this.handleChangeFilter(e, val.name)}
																			className="col-md-10 basic-multi-select"
																			classNamePrefix="select"
																		/>
																	</Col>
																	:
																	<Col xs="12" sm="8" md="9">
																		<Input placeholder={val.displayName} onChange={(e) => this.handleChangeFilter(e.target.value, val.name)} />
																	</Col>
														}
													</Row>
												</Col>
											)
										})
									}
								</Row>
								<Row>
									<Col sm="12" md="12" style={{ padding: '20px 5px 5px 5px' }}>
										<div style={{ textAlign: 'end' }}>
											<Button color="primary" onClick={() => this.handleSearchSubmit()} ><i class="fa fa-search" aria-hidden="true"></i> Search</Button>
										</div>
									</Col>
								</Row>
							</div>
						</CardBody>
					</Card>
					<Card style={{ margin: '10px' }}>
						<CardHeader><i class="fa fa-mobile fa-2x" aria-hidden="true"></i> รุ่นที่ใช้ร่วมกันได้</CardHeader>
						<CardBody>
							<CustomAlert open={this.state.customAlert.open} messages={this.state.customAlert.messages} status={this.state.customAlert.status} />
							{
								departmentRole !== 'D11' ? '' : <div style={{ padding: '0px 10px' }}><Button onClick={() => this.handleEdit(-1)} color="primary" ><i class="fa fa-plus" aria-hidden="true"></i> Add</Button></div>

							}
							<div style={{ margin: '10px' }}>
								<BootstrapTable style={{ display: 'block !important' }} wrapperClasses="table-responsive" keyField='id' data={productData} columns={columns} pagination={paginationFactory()} />
							</div>
						</CardBody>
					</Card>
					<ModelModal
						open={this.state.openModal}
						close={this.closeModalEdit}
						productById={this.state.productById}
						sameModelId={this.state.sameModelId}
						type={this.state.type}
						handleSearchSubmit={this.handleSearchSubmit}
						setCustomAlert={this.setCustomAlert}
					/>
				</div>
				<div id="showImg" class="modal">
					<span class="close" onClick={() => this.handleCloseDisplayImg()} >&times;</span>
					<img class="modal-content" id="imgContent" />
				</div>
			</React.Fragment>
		);
	}
}

export default Film_DisplaySameModel;

class ModelModal extends Component {

	state = {
		filterListData: [
			{
				displayName: 'IBrand 2',
				name: 'iBrand2',
				value: '',
				inputType: 'option',
				option: [],
			},
			{
				displayName: 'Model',
				name: 'modelDesc',
				value: '',
				inputType: 'textarea',
				option: [],
			},
			{
				displayName: 'Size',
				name: 'sizeDesc',
				value: '',
				inputType: 'text',
				option: [],
			},
			{
				displayName: 'Range Price',
				name: 'rangePrice',
				value: '',
				inputType: 'text',
				option: [],
			},
			{
				displayName: 'Remark',
				name: 'remark',
				value: '',
				inputType: 'text',
				option: [],
			},
		],
		productById: [],
		sameModelId: 0,
		typeAdd: false,
		customAlert: {
			open: false,
			messages: '',
			status: ''
		},
		openConfirmDelete: false,
		deleteModelId: [],
	}

	componentDidMount() {
		this.get_Ibrand2Filter()
	}

	get_Ibrand2Filter = () => {
		let url = proxy.server + '/flim/getIbrand2Filter'
		fetch(url, {
			method: "POST",
			headers: {
				// Accept: "application/json",
				"Content-Type": "application/json;charset=utf-8"
			},
			body: JSON.stringify({ id: "GET_ALL" })
		})
			.then(response => response.json())
			.then((responseJson) => {
				console.log("responseJson [get_productNameFilter]", responseJson)
				let filterListData = this.state.filterListData
				let arr = []

				switch (responseJson.status) {
					case 200:
						responseJson.result.map(function (val, i) {
							arr.push({ value: val.iBrand2Id, label: val.iBrand2Name })
						})
						filterListData[0].option = arr;
						this.setState({ filterListData: filterListData })
						break;
					default:
						filterListData[0].option = arr;
						this.setState({ filterListData: filterListData })
				}
			})
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.type === 'add') {
			console.log('object else if first', this.state.typeAdd)
			if (this.state.typeAdd === false) {
				console.log('object else if second')

				let filterListData = this.state.filterListData.slice()
				filterListData.map((val, i) => {
					val.value = ''
				})

				console.log('object this.state.sameModelId this.state.sameModelId', this.state.sameModelId)

				// if (this.state.sameModelId === 0) {
				console.log('object set value')
				this.setState({ productById: [], sameModelId: '', filterListData: filterListData }, () => {
					this.setState({ typeAdd: true })
				})
			}
		} else if (this.props.type === 'edit') {
			if (!!this.props.productById && this.props.productById.length > 0) {
				console.log('first if')
				console.log('first if this.props.productById', this.props.productById)
				console.log('first if this.state.productById', this.state.productById)
				// console.log('first if ', this.state.productById.length)
				if (!!this.state.productById && this.state.productById.length === 0) {
					console.log('second if')
					let filterListData = this.state.filterListData.slice()
					let productById = this.props.productById[0]
					filterListData.map((val, i) => {
						for (let key in productById) {
							if (val.name === key) {
								val.value = productById[key]
							}
						}
					})
					console.log('object arr', filterListData)
					console.log('object arr productById', productById)
					if (prevState.productById !== prevProps.productById) {
						console.log('object prevState.productById !== prevProps.productById')
						this.setState({ productById: productById, sameModelId: productById.sameModelId, filterListData: filterListData })
					}
				}
			}
		}
	}

	saveSameModel = (data) => {
		this.props.setCustomAlert('กำลังประมวลผล', 'processing')

		let url = proxy.server + '/flim/uploadSameModel'
		fetch(url, {
			method: "POST",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json;charset=utf-8"
			},
			body: JSON.stringify({ data: data })
		})
			.then(response => response.json())
			.then(responseJson => {
				console.log('object [saveSameModel]', responseJson)
				switch (responseJson.status) {
					case 200:
						this.props.handleSearchSubmit()
						//todo เรียก service ใหม่เพื่อรีเฟรชตาราง
						this.props.close()


						let filterListData = this.state.filterListData.slice()
						filterListData.map((val, i) => {
							val.value = ''
						})
						this.setState({ filterListData: filterListData, productById: [], sameModelId: 0, typeAdd: false, })

						this.props.setCustomAlert('บันทึกสำเร็จ', 'success')
						break;
					default:
						this.props.setCustomAlert('ไม่สามารถทำรายการได้ กรุณาติดต่อเจ้าหน้าที่', 'error')
				}
			})
	}

	close = () => {
		this.props.close()
		let filterListData = this.state.filterListData.slice()
		filterListData.map((val, i) => {
			val.value = ''
		})
		this.setState({ filterListData: filterListData, productById: [], sameModelId: 0, typeAdd: false, })
	}

	handleSave = () => {
		console.log('handleSave', this.state.filterListData)

		let preObj
		if (this.state.sameModelId === '') {
			preObj = {}
		} else {
			preObj = {
				sameModelId: this.state.sameModelId,
			}
		}

		let isValid = true

		this.state.filterListData.map((val, i) => {
			preObj[`${val.name}`] = val.value;
			if (val.name === 'iBrand2' && val.value === '') {
				isValid = false
			}
		})

		if (isValid) {
			this.saveSameModel(preObj)
		} else {
			alert('กรุณาเลือก iBrand2')
		}
	}

	handleChangeFilter = (value, fieldName) => {
		let filterListData = this.state.filterListData
		console.log('object value', value)
		filterListData.map((val, i) => {
			if (val.name === fieldName) {
				if (value === null) {
					// for uploadContent filter
					value = []
				}
				val.value = value
			}
		})
		console.log('object filterList filterList [handleChangeFilter]', filterListData)
		this.setState({ filterListData: filterListData })
	}

	handleDelete = () => {
		let deleteModelId = [...this.state.deleteModelId]
		deleteModelId.push(this.state.sameModelId)
		this.setState({ openConfirmDelete: true, deleteModelId: deleteModelId })
	}

	closeConfirmDelete = () => {
		this.setState({ openConfirmDelete: false, deleteModelId: [] })
		this.close()
	}

	render() {

		let productById = !!this.props.productById[0] && this.props.productById[0]

		return (
			<Modal isOpen={this.props.sameModelId !== -1 ? this.props.open === productById.sameModelId : this.props.open === 0} >
				<ModalHeader>{this.props.sameModelId !== -1 ? "Edit Model" : "Add Model"}</ModalHeader>
				<ModalBody>
					<div style={{ padding: '10px' }}>
						<Row>
							{
								this.state.filterListData.map((val, i) => {
									return (
										<Col xs="12" sm="12" md="12" style={{ padding: '5px' }}>
											<Row>
												<Col xs="12" sm="4" md="4">{val.displayName}:</Col>

												{
													val.inputType === 'option' ?
														<Col xs="12" sm="8" md="8">
															<Select
																defaultValue={val.option.filter(option => option.label === val.value.toUpperCase())}
																value={val.option.filter(option => option.label === val.value.toUpperCase())}
																onChange={(e) => this.handleChangeFilter(e.value, val.name)}
																options={val.option}
																placeholder={'ค้นหา ' + val.displayName}
															/>
														</Col>
														: val.inputType === 'textarea' ?
															<Col xs="12" sm="8" md="8">
																<Input type="textarea" rows="3" placeholder={val.displayName} defaultValue={val.value} onChange={(e) => this.handleChangeFilter(e.target.value, val.name)} />
															</Col> :
															<Col xs="12" sm="8" md="8">
																<Input type="text" placeholder={val.displayName} defaultValue={val.value} onChange={(e) => this.handleChangeFilter(e.target.value, val.name)} />
															</Col>
												}
											</Row>
										</Col>
									)
								})
							}
						</Row>
					</div>
				</ModalBody>
				<ModalFooter>
					{
						this.props.type === 'edit' &&
						<div style={{ width: '50%' }}>
							<Button onClick={() => this.handleDelete()} color="danger"><i class="fa fa-trash" aria-hidden="true"></i> Delete</Button>
						</div>
					}

					<div style={{ textAlign: 'end', width: '50%' }}>
						<Button color="success" onClick={() => this.handleSave()} >Save</Button> &nbsp;
						<Button color="secondary" onClick={() => this.close()} >Cancel</Button>
					</div>
				</ModalFooter>
				<ConFirmDelete open={this.state.openConfirmDelete} deleteModelId={this.state.deleteModelId} close={this.closeConfirmDelete} handleSearchSubmit={this.props.handleSearchSubmit} setCustomAlert={this.props.setCustomAlert} />
			</Modal>
		);
	}
}

class ConFirmDelete extends Component {

	state = {

	}


	deleteData = () => {
		console.log('object delete', this.props.deleteModelId)

		this.props.setCustomAlert('กำลังประมวลผล', 'processing')

		let url = proxy.server + '/flim/deleteSameModel'
		fetch(url, {
			method: "POST",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json;charset=utf-8"
			},
			body: JSON.stringify({
				id: this.props.deleteModelId,
			})
		})
			.then(response => response.json())
			.then((responseJson) => {
				switch (responseJson.status) {
					case 200:
						this.close()
						this.props.handleSearchSubmit()
						// this.setState({ deleteList: [] })
						this.props.setCustomAlert('บันทึกสำเร็จ', 'success')
						break;
					default:
						this.props.setCustomAlert('ไม่สามารถทำรายการได้ กรุณาติดต่อเจ้าหน้าที่', 'error')
				}
			})
	}

	close = () => {
		this.props.close()
	}

	render() {


		return (
			<Modal isOpen={this.props.open} >
				<ModalHeader>Confirm Delete</ModalHeader>
				<ModalBody>
					<div style={{ padding: '10px' }}>
						<Row>
							<p>ต้องการลบข้อมูลนี้ โปรดกดยืนยัน</p>
						</Row>
					</div>
				</ModalBody>
				<ModalFooter>
					<div style={{ textAlign: 'end' }}>
						<Button color="danger" onClick={() => this.deleteData()} >Delete</Button> &nbsp;
						<Button color="secondary" onClick={() => this.close()} >Cancel</Button>
					</div>
				</ModalFooter>
			</Modal>
		);
	}
}


function CustomAlert(props) {
	/* status => processing, success, warning, error */
	return (
		props.open && <Alert color={props.status === 'processing' ? 'secondary' : props.status}>
			{props.status === 'processing' && <Spinner size="sm" color="secondary" />} {props.messages}
		</Alert>
	)
}